import Big from 'big.js'
import { fromUnit, toUnit } from 'metronome-utils'
import { useContext } from 'react'
import useSWR from 'swr'

import { MetronomeContext } from '../components/MetronomeContext'

/**
 * Get the rate to convert from tokenA to tokenB. Keep refreshing the rate on intervals
 * @param tokenA The token to convert from
 * @param tokenB The token to convert to
 * @param amount Amount of tokenA to use as reference for conversion to get the rate
 * @param refreshInterval
 * @returns {(*|boolean)[]}
 */
export const useRefreshedRate = function ({
  tokenA,
  tokenB,
  amount = 1,
  refreshInterval = 10 * 1000
}) {
  const { metronome } = useContext(MetronomeContext)
  const cacheKey =
    tokenA && tokenB
      ? `rate-${tokenA?.symbol || ''}-${tokenB?.symbol}-${toUnit(
          amount,
          tokenA?.decimals
        )}`
      : null

  const { data: rate, error } = useSWR(
    cacheKey,
    function () {
      const _amountToConvert = toUnit(amount, tokenA.decimals)
      return metronome
        .convert(tokenA.address, tokenB.address, _amountToConvert)
        .then(function (_amountOut) {
          if (Big(amount).eq(0)) {
            return Big(0)
          }
          return Big(fromUnit(_amountOut, tokenB.decimals)).div(amount)
        })
    },
    { refreshInterval }
  )

  return [rate, tokenA && tokenB && !error && !rate, cacheKey]
}

export default useRefreshedRate
